import { Link } from "react-router-dom";

export function SectionHeader({
  title,
  hint,
  to,
  actionLabel = "See all",
}: {
  title: string;
  hint?: string;
  to?: string;
  actionLabel?: string;
}) {
  return (
    <div className="mb-3 flex items-end justify-between gap-3">
      <div>
        <h2 className="font-display text-sm font-semibold lg:text-base">{title}</h2>
        <div className="mt-1 h-0.5 w-8 rounded-full bg-gradient-brand" aria-hidden />
        {hint ? <p className="mt-1 text-[10px] text-brand-pink/80">● {hint}</p> : null}
      </div>
      {to ? (
        <Link to={to} className="shrink-0 text-[11px] font-semibold text-brand-pink hover:underline">
          {actionLabel} →
        </Link>
      ) : null}
    </div>
  );
}
